__webpack_require__.p = "https://cart.core-artifacts.com/static/";